import useSWR from 'swr';

import { IUser } from 'containers/Setting/Users/api';
import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { buildQuery, fetcher } from './utils';

export const useUser = (id: number) => {
  const { data, error, isLoading, mutate, isValidating } = useSWR<IDetailResponse<IUser>>(
    id ? `/v4/dash/users/${id}` : null,
    fetcher
  );
  return { data: data?.data, error, isLoading, mutate, isValidating };
};

export const useUserList = (params: Record<string, any>) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<IPaginatedResponse<IUser>>(
    `/v4/dash/users?${buildQuery(params)}`,
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};

export const useUsersByIds = (ids: Array<number | string> = []) => {
  const sanitizedIds = ids.filter(id => id !== null && id !== undefined);
  const key = sanitizedIds.length > 0 ? ['usersByIds', sanitizedIds.join(',')] : null;
  const { data, isLoading, error, mutate, isValidating } = useSWR<IUser[]>(key, async () => {
    const responses = await Promise.all(
      sanitizedIds.map(
        async id => (await fetcher(`/v4/dash/users/${id}`)) as IDetailResponse<IUser>
      )
    );

    return responses.map(response => response?.data).filter(Boolean);
  });

  return { data, isLoading, error, mutate, isValidating };
};
